

<template>
    <div class="grid w-full grid-cols-1 md:grid-cols-4 lg:w-2/3 md:gap-4">
        <div v-for="filterBox in  filter_bar" :key="filterBox.id" class="w-full flex items-center">
          <label :for="`item_category_${filterBox.id}`"
            class="sr-only2 mr-2 text-sm font-bold text-right truncate w-full">{{ filterBox.name[lg] }}
            :</label>

          <select :id="`item_category_${filterBox.id}`" :value="filterBox.selected"
            class="block py-1.5 px-0 w-full text-sm text-gray-500 bg-transparent    font-bold  border border-gray-200 appearance-none   focus:outline-none focus:ring-0 focus:border-gray-200 peer"
            @change="changeSelect($event, filterBox.data)">
            <option v-for="filterOption in filterBox.values" :key="filterOption.value" :value="filterOption.value">
              &nbsp;{{ filterOption.name[lg] ? filterOption.name[lg] :
              filterOption.name }}
            </option>
          </select>
        </div>
      </div>


</template>

<script>
export default {
    name: 'TableFilterBar',

    components: {
       
    },
    props: {
        filter_bar: Array
    }
}
</script>
